export default __webpack_public_path__ + "static/media/email white.4122666d.svg";